import * as React from 'react';
import { useContext } from 'react';

import type { EnterpriseHomePageQuery_EnterpriseLearnerSummariesV1Resource_byUserIdAndThirdPartyOrgSlug_elements_enterprisePrograms_elements as EnterpriseProgram } from 'bundles/program-home/components/enterprise-home/__generated__/EnterpriseHomePageQuery';

const AllEnterpriseProgramsContext = React.createContext<EnterpriseProgram[] | undefined>(undefined);

export const useAllEnterprisePrograms = () => {
  const programsContext = useContext(AllEnterpriseProgramsContext);

  return programsContext;
};

export default AllEnterpriseProgramsContext;
